import React from 'react'
import { FiUser } from 'react-icons/fi'

export default function () {
	return (
		<div className="min-h-screen flex justify-center items-center flex-col text-slate-800 gap-8 mx-4">
			<FiUser size={64} />
			<h1 className="text-slate-800 text-center">Você está autenticado como ADMINISTRADOR.</h1>
		</div>
	)
}
